// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","table":"_2L-O8N0Hn9Q03-8w8Hhpsg","tableRow":"_3PUSiTMWP-3IF2-Yu14g1p","th":"_12KsZIu7HI-9o-lx-EaXD-","td":"_1JhOB5NRsMnm4dA1BeKu62"};